import React, { useMemo, useState } from 'react'

import { Checkbox, Col, Input, Row } from 'antd'

import { getMessage } from '../../../../../../util/IntlMessages'

import './styles.less'

export function ListWithCheckbox({ label, field, optionsList, values, setFieldValue }) {
  const [search, setSearch] = useState('')

  const options = useMemo(
    () =>
      optionsList?.map(({ value, description }) => ({
        label: description,
        value
      })),
    [optionsList]
  )

  const fileteredOptions = useMemo(
    () =>
      search.length > 0 ? options.filter(({ label }) => label.toLowerCase().includes(search.toLowerCase())) : options,
    [options, search]
  )

  function handleCheckAll({ target }) {
    if (target.checked) {
      setFieldValue(
        field,
        options.map(({ value }) => value)
      )
    } else {
      setFieldValue(field, [])
    }
  }

  function handleGroupCheck(checkedList) {
    setFieldValue(field, checkedList)
  }

  const isAllChecked = useMemo(() => {
    return options.length === values.length
  }, [options, values])

  return (
    <div className="listWithCheckbox">
      <span className="listWithCheckbox__label">{label}</span>
      <Input.Search
        onInput={({ target }) => setSearch(target.value)}
        placeholder={getMessage('search')}
        className="listWithCheckbox__input"
      />

      <Row>
        <Col span={24} className="listWithCheckbox__outerBorder">
          <Checkbox className="listWithCheckbox__checkAll" onChange={handleCheckAll} checked={isAllChecked}>
            {isAllChecked ? getMessage('unmarkAll') : getMessage('markAll')}
          </Checkbox>
          <Checkbox.Group
            className="listWithCheckbox__checkboxGroup"
            options={fileteredOptions}
            value={values}
            name="listWithCheckbox"
            onChange={handleGroupCheck}
          />
        </Col>
      </Row>
    </div>
  )
}
